import React from 'react';
import { Layers } from '@mui/icons-material'
import {
    Menu,
    MenuItem,
    Checkbox,
    FormControlLabel,
    Typography,
    Divider
} from '@mui/material';
import { BASE_LAYER_LIST, CHRONOLOGY_LAYER_LIST } from '../const/map_config'
import { LayersIconButton } from '../style/map_components';

const MapSwitchLayerIcon = (props) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e) => {
        props.setShouldClearSelect(true)
        // 明示的に比較して変わってるときだけ更新
        props.setSelectLayer((prev) => {
            const new_layer = BASE_LAYER_LIST.find(p => p.category === e);
            return prev === new_layer ? prev : new_layer;
        });
        setAnchorEl(null);
    };

    const handleChange = (event) => {
        const { name, checked: isChecked } = event.target;
        if (props.setSelectLayerList) {
            props.setSelectLayerList(prev => ({
                ...prev,
                [name]: isChecked,
            }));
        }
    };

    // アイコンのスタイル
    const iconStyle = { width: '21px', height: '21px' }

    return (
        <>
            <LayersIconButton
                onClick={handleClick}>
                <Layers sx={iconStyle} />
            </LayersIconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button'
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={() => handleClose(props.selectLayer.category)}
                slotProps={{
                    paper: {
                        style: {
                            maxHeight: 48 * 4.5
                        }
                    }
                }}
            >
                {BASE_LAYER_LIST.map((elem) => (
                    <MenuItem
                        sx={{
                            fontSize: '12px',        // ← 文字サイズ
                            paddingY: '2px',         // ← 上下の余白
                            paddingX: '8px',        // ← 左右の余白
                        }}
                        key={elem.category}
                        selected={props.selectLayer.category === elem.category}
                        onClick={() => handleClose(elem.category)}
                    >
                        {elem.name}
                    </MenuItem>
                ))}
                {(props.pageType === 'summary') && (
                    <>
                        <Divider sx={{ borderColor: 'rgba(0,0,0,0.25)' }} />
                        {CHRONOLOGY_LAYER_LIST.map((item) => (
                            <MenuItem key={item.category}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            size="small"
                                            sx={{ padding: 0 }}
                                            name={item.category}
                                            checked={props.selectLayerList?.[item.category] || false}
                                            onChange={handleChange}
                                        />
                                    }
                                    label={
                                        <Typography sx={{ fontSize: '12px' }}>
                                            {item.name}
                                        </Typography>
                                    }
                                />
                            </MenuItem>
                        ))}
                    </>
                )}
            </Menu>
        </>
    );
};

export default MapSwitchLayerIcon;